<template>
  <div>
    <transition name="slide" appear>
      <section class="modal">
        <div class="deleteProfile popUp wp470" v-if="!accountDeleteMessage">
          <div class="flex title">
            <h4>{{ $t("profile.delete_profile") }}</h4>
            <a class="close" href v-on:click.prevent="closePopup()"
              ><span class="icon warpit_icon_x"></span
            ></a>
          </div>
          <img src="@/assets/images/alertIcon.svg" width="140px" />
          <h4>{{ $t("profile.delete_profile_confirm") }}</h4>
          <div class="flex">
            <div class="col1_3">
              <label class="switch">
                <input type="checkbox" v-on:click="confrimClicked()" />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="col2_3">
              <p>
                {{ $t("profile.delete_profile_agree_text") }}
              </p>
            </div>
          </div>
          <div class="next flex">
            <div class="fullWidth flex">
              <button :disabled="!isConfrimDeleteProfile"
                      class="delete-profile-button"
                      v-bind:class="{'light':!isConfrimDeleteProfile}"
                      v-on:click.prevent="requestDeleteProfile()">
                {{$t("profile.delete_profile_ok") }}
              </button>
            </div>
            <a
              class="join smallFont hoverEffect"
              ref="joinButton11"
              v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton11')"
              v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton11')"
              href
              v-on:click.prevent="canclePopup()"
            >
              <label>{{ $t("profile.delete_profile_cancel") }}</label
              ><span
                class="effect"
                ref="effectButton11"
                v-bind:style="{ top: topX1 + 'px', left: leftX1 + 'px' }"
              ></span
            ></a>
          </div>
        </div>
        <AccountDeleteVerification 
          v-if="accountDeleteMessage" 
          @closeDeleteMessage="closeDeleteMessage($event)"
        />
      </section>
    </transition>
  </div>
</template>

<script>
import AccountDeleteVerification from './AccountDeleteVerification';
import { formUtilsMouseHoverEffect} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      name: "mojtaba",
      topX1: 1,
      leftX1: 1,
      confirmDeleteProfile: false,
      select1: 3,
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 2 },
        { text: "Thor Ragnarok", value: 3 },
      ],
      value1: "",
      value2: "",
      popupActivo2: false,
      popupActivo3: false,
      isConfrimDeleteProfile: false,
      accountDeleteVerification:false,
      accountDeleteMessage:false
    };
  },
  mounted() {},
  computed: {},
  methods: {
    formUtilsMouseHoverEffect,

    confrimClicked() {
      this.isConfrimDeleteProfile =
        this.isConfrimDeleteProfile === false ? true : false;
    },
    requestDeleteProfile() {
      this.accountDeleteMessage = true;
      this.$emit("closeDeleteProfile", this.isConfrimDeleteProfile);
    },
    closePopup() {
      this.$emit("closeDeleteProfile", false);
    },
    canclePopup() {
      this.$emit("closeDeleteProfile", false);
    },
    closeDeleteMessage(event){
        this.$emit("closeDeleteMessage", true);
   }
  },
  components:{
    AccountDeleteVerification
  }
};
</script>

<style >
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;

  width: 100%;
  max-width: 480px;
}
.modal .popUp {background: #fff; margin: 1px !important;}

button.delete-profile-button{
  font-family: 'AvenirNextBold', sans-serif;
  font-size:18px;
  font-weight:400;
  line-height: 22px; 
  text-align: center;
  margin-bottom: 10px;
  text-decoration: none;
  color: #0297A7;
  outline:none;
  box-shadow:none;
  border:none;
  padding:0px;
  position:relative;
  background:transparent;
  cursor:pointer;
}
button.delete-profile-button.light{
  font-family:'Avenir Next LT Pro Regular', sans-serif;
}
button.delete-profile-button:disabled {
  color: #89D3E2;
  cursor: default;
}
button.delete-profile-button:disabled:after {
  background: transparent;
}
button.delete-profile-button:after{
  content: '';
  display: block;
  width: 0;
  height: 3px;
  background: #0297A7;
  -webkit-transition: width .3s;
  transition: width .3s;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
}
button.delete-profile-button:hover:after{
  width:100%;
}
</style>
